export const LOADING = 'addEditContributor.LOADING';
export const LOADED = 'addEditContributor.LOADED';